import { useEffect } from 'react';
import { api } from './api';

const MOVE_EPS = 0.02;
const MIN_RESEND_MS = 30 * 60 * 1000;
const round2 = (n: number) => Math.round(n * 100) / 100;

let last: { lat: number; lon: number; at: number } | null = null;

// 上报前取整到2位小数(~1km) — 服务端永远拿不到精确位置
function report() {
  if (!('geolocation' in navigator)) return;
  navigator.geolocation.getCurrentPosition(
    (pos) => {
      const lat = round2(pos.coords.latitude);
      const lon = round2(pos.coords.longitude);
      const now = Date.now();
      if (
        last &&
        Math.abs(lat - last.lat) < MOVE_EPS &&
        Math.abs(lon - last.lon) < MOVE_EPS &&
        now - last.at < MIN_RESEND_MS
      )
        return;
      api
        .reportLocation(lat, lon)
        .then(() => {
          last = { lat, lon, at: now };
        })
        .catch(() => {});
    },
    () => {},
    { enableHighAccuracy: false, maximumAge: 600_000, timeout: 10_000 },
  );
}

export function useGeo(): void {
  useEffect(() => {
    report();
    const onVis = () => {
      if (!document.hidden) report();
    };
    document.addEventListener('visibilitychange', onVis);
    const t = window.setInterval(() => {
      if (!document.hidden) report();
    }, 15 * 60 * 1000);
    return () => {
      document.removeEventListener('visibilitychange', onVis);
      window.clearInterval(t);
    };
  }, []);
}
